module.exports = __webpack_public_path__ + "static/img/background.712370e.png";